import { render } from "./issue-Details.vue?vue&type=template&id=5fbd3d61&scoped=true"
import script from "./issue-Details.vue?vue&type=script&lang=js"
export * from "./issue-Details.vue?vue&type=script&lang=js"

import "./issue-Details.vue?vue&type=style&index=0&id=5fbd3d61&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5fbd3d61"

export default script